var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help"},[(_vm.list.data.length)?_vm._l((_vm.list.data),function(item){return _c('p',{key:item.id,staticClass:"item",on:{"click":function($event){return _vm.tagFaq(item.id)}}},[_vm._v(_vm._s(item.title))])}):[_c('p',{staticClass:"no-question"},[_vm._v("Unable to find the relevant issue you searched for.")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }